import onGetAiSystemSettings from './onGetAiSystemSettings';
import onGetAiClinicSettings from './onGetAiClinicSettings';
import onUpdateAiSystemSettings from './onUpdateAiSystemSettings';
import onUpdateAiClinicSettings from './onUpdateAiClinicSettings';
import onSendAiRequest from './onSendAiRequest';
// eslint-disable-next-line import/extensions -- ts: 'never' in config, resolver false positive for new files
import onGetAiModels from './onGetAiModels';

export default {
  onGetAiSystemSettings,
  onGetAiClinicSettings,
  onUpdateAiSystemSettings,
  onUpdateAiClinicSettings,
  onSendAiRequest,
  onGetAiModels,
};
